import React from 'react';
import { motion } from 'framer-motion';
import { TruckIcon, BadgeCheckIcon, TagIcon, HeadphonesIcon } from 'lucide-react';
const FEATURES = [{
  icon: TagIcon,
  title: 'Prix de gros',
  text: 'Les meilleurs tarifs négociés pour vous.'
}, {
  icon: BadgeCheckIcon,
  title: 'Qualité garantie',
  text: 'Des produits sélectionnés avec soin.'
}, {
  icon: TruckIcon,
  title: 'Approvisionnement rapide',
  text: 'Livraison fiable et régulière.'
}, {
  icon: HeadphonesIcon,
  title: 'Accompagnement',
  text: 'Une équipe à votre écoute.'
}];
export function Features() {
  return <section className="w-full bg-ardis-green py-16" data-id="element-156" data-mp="1o4qhbcwwhd4s">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-8 px-5 sm:grid-cols-2 lg:grid-cols-4 lg:px-8" data-id="element-157" data-mp="1a6jviv5873lh">
        {FEATURES.map((f, i) => <motion.div key={f.title} initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.5,
        delay: i * 0.1
      }} className="flex flex-col items-center text-center" data-id="element-158" data-mp="3uxkb0z42vh12" data-mpi={i}>
            <div className="flex h-14 w-14 items-center justify-center rounded-full bg-ardis-yellow" data-id="element-159" data-mp="2svdc4zxwg2zk">
              <f.icon className="h-7 w-7 text-ardis-green-dark" data-id="element-160" data-mp="36uv8c0diyiiy" />
            </div>
            <h3 className="mt-4 font-display text-lg font-semibold text-white" data-id="element-161" data-mp="32t9m3of3orw3">{f.title}</h3>
            <p className="mt-1.5 text-sm text-white/70" data-id="element-162" data-mp="3gsssabocpt5r">{f.text}</p>
          </motion.div>)}
      </div>
    </section>;
}